import React from "react";
import Png from "../media/Error_404_PNG.png";
import { Box, Typography } from "@mui/material";

const notFound = () => {
  return (
    <Box id="notfound" sx={{textAlign: 'center', mt: 4}}>
        <div className="notfound-404">
          <img src={Png} width="100%" style={{maxWidth: '500px'}} alt="Not Found" />
          <Typography variant="h5" component="h2" sx={{mt: 2}}>We are sorry, but the page you requested was not found</Typography>
        </div>
    </Box>
  );
};

export default notFound;
